/**
 * Ahlam editorial media injector.
 * Where Horizon has rendered a placeholder SVG (no image picked) inside a
 * media-block, inject an actual <img> with a curated Unsplash editorial photo
 * so the layout feels finished even before the user uploads brand photography.
 *
 * Mapping is by section id. Safe-no-op when an image is already present.
 */
(function () {
  if (typeof window === 'undefined') return;

  /** @type {Record<string, string>} */
  const SECTION_IMAGES = {
    'shopify-section-story_split_1':
      'https://images.unsplash.com/photo-1615634376658-c80abf877609?w=2400&q=85&fm=jpg&auto=format',
    'shopify-section-story_split_2':
      'https://images.unsplash.com/photo-1615634260167-c8cdede054de?w=2400&q=85&fm=jpg&auto=format',
    'shopify-section-about_hero':
      'https://images.unsplash.com/photo-1615634376658-c80abf877609?w=2400&q=85&fm=jpg&auto=format',
  };

  /** @type {Record<string, string>} */
  const HERO_SCENT_IMAGES = {
    floral:
      'https://images.unsplash.com/photo-1518790802543-8e468f44ce9d?w=1400&q=85&fm=jpg&auto=format',
    oud: 'https://images.unsplash.com/photo-1602928298849-325cec8771c0?w=1400&q=85&fm=jpg&auto=format',
    fresh:
      'https://images.unsplash.com/photo-1503342394128-c104d54dba01?w=1400&q=85&fm=jpg&auto=format',
    musk: 'https://images.unsplash.com/photo-1547887537-6158d64c35b3?w=1400&q=85&fm=jpg&auto=format',
  };

  const ensureImg = (mediaBlock, src, alt) => {
    if (!mediaBlock) return;
    if (mediaBlock.querySelector('img.ahlam-injected')) return;
    // If there is already a real product/uploaded img (not placeholder svg), keep it
    const existingRealImg = mediaBlock.querySelector('img:not(.ahlam-injected)');
    if (existingRealImg) return;

    // Remove placeholder svg
    const svg = mediaBlock.querySelector('svg.placeholder-svg, .placeholder-svg svg, svg');
    if (svg && svg.closest('.media-block__media')) {
      svg.style.display = 'none';
    }

    const slot = mediaBlock.querySelector('.media-block__media') || mediaBlock;
    const img = document.createElement('img');
    img.className = 'ahlam-injected media-block__media border-style';
    img.src = src;
    img.alt = alt || '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.objectPosition = 'center';
    img.style.display = 'block';
    img.style.minHeight = '520px';
    slot.appendChild(img);
  };

  const init = () => {
    // 1. Inject Unsplash media-block images per section
    Object.keys(SECTION_IMAGES).forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (!section) return;
      const mediaBlocks = section.querySelectorAll('.media-block');
      mediaBlocks.forEach((mb) => ensureImg(mb, SECTION_IMAGES[sectionId], ''));
    });

    // 2. Scent grid cards — attach data-scent attr so CSS bg targeting works robustly
    const scentSection = document.getElementById('shopify-section-scent_grid');
    if (scentSection) {
      const cards = scentSection.querySelectorAll('.group-block .group-block, [class*="group-block"]');
      cards.forEach((card) => {
        const text = (card.textContent || '').toLowerCase();
        let key = null;
        if (text.includes('floral')) key = 'floral';
        else if (text.includes('oud')) key = 'oud';
        else if (text.includes('fresh') || text.includes('citrus')) key = 'fresh';
        else if (text.includes('musk') || text.includes('amber')) key = 'musk';
        if (key) {
          card.setAttribute('data-scent', key);
          // Also paint inline as fallback in case the selector misses
          if (!card.style.backgroundImage) {
            card.style.backgroundImage = `url('${HERO_SCENT_IMAGES[key]}')`;
            card.style.backgroundSize = 'cover';
            card.style.backgroundPosition = 'center';
          }
        }
      });
    }

    // 3. Hero section — if no hero image rendered, the CSS bg pseudo handles it.
    //    Just tag the section for parallax.
    const heroSection = document.getElementById('shopify-section-hero_main');
    if (heroSection) {
      heroSection.setAttribute('data-ahlam-hero', '1');
    }
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }

  // Late re-init for sections that hydrate after first paint (Horizon section renderer)
  window.addEventListener('load', () => setTimeout(init, 600));
})();
